/* eslint-disable no-unused-vars */
import React from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import { useFetchAnalystData } from "./api/useFetchAnalystData";
import { Alert, Col, Container, Row } from "react-bootstrap";
import { AnalystListing } from "./parts/AnalystListing";
import { AnalystPaginationControl } from "./parts/AnalystPaginationControl";
import { AnalystFilters } from "./menu/AnalystFilters";
import { _t, i18n } from "app/i18n/i18n";
import { isPublicPath } from "lib/routing";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { AnalystSidebar } from "./sidebar/AnalystSidebar";

export const AnalystDirectory = () => {
  const [groups, isLoading, isError, data, hits, aggs] = useFetchAnalystData();
  const qs = useQueryParams();
  if (isPublicPath()) i18n.setLanguage(qs.lang || "ja");

  return (
    <ErrorBoundary>
      <section className="py-1">
        <AnalystFilters />

        <Container fluid>
          <Row>
            <Col md="3">
              <AnalystSidebar aggs={aggs} />
            </Col>

            <Col md="9">
              {!isLoading && !hits.length && !isError ? <NoAnalystMatches /> : null}
              {isError && <DataErrorMsg />}
              {Object.entries(groups).map(([group, specialities]) => (
                <AnalystListing key={group} group={group} specialities={specialities} />
              ))}
            </Col>
          </Row>
        </Container>

        <AnalystPaginationControl pageSize={200} numHits={data.hits ? data.hits.total.value : 0} />
      </section>
    </ErrorBoundary>
  );
};

const NoAnalystMatches = () => (
  <Alert variant="warning my-3">
    {_t("No Analysts match the specified search criteria. Please adjust the search criteria above.")}
  </Alert>
);

export const DataErrorMsg = () => (
  <Alert variant="warning m-3">{_t("Sorry this data is not currently available, please try again later.")} </Alert>
);
